import {
  Button,
  ButtonGroup,
  Divider,
  Paper,
  Stack,
  TextField,
  Typography,
  useColorScheme,
} from "@mui/material"
import { Check, Save01 } from "@untitled-ui/icons-react"
import { useContext, useEffect, useState } from "react"

import { PageWrapper } from "../components/PageWrapper"
import { TitleBar } from "../components/TitleBar"
import { Config as ConfigType, ConfigContext, defaultConfig } from "../contexts/config"

export default function Config() {
  useEffect(() => {
    document.title = "Config · Botega"
  }, [])

  // config
  const [config, updateConfig] = useContext(ConfigContext)

  // unsaved config
  const [tempConfig, setTempConfig] = useState<ConfigType>(defaultConfig)

  useEffect(() => setTempConfig(config), [config])

  // show saved icon
  const [saved, setSaved] = useState(false)

  function save() {
    updateConfig(tempConfig)
    setSaved(true)
    setTimeout(() => setSaved(false), 1500)
  }

  const { mode, setMode } = useColorScheme()

  return (
    <PageWrapper sx={{ width: { sm: 550 } }}>
      <TitleBar variant="solid" title="Configuration" />
      <Paper
        elevation={0}
        sx={{
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          padding: 1,
        }}
      >
        <Stack
          gap={1}
          sx={(theme) => ({
            "& > div": {
              padding: 1,
              display: "grid",
              alignItems: "center",
              gridTemplateColumns: "1fr 1fr",
            },

            "& > div input": {
              textAlign: "right",
            },
            [theme.breakpoints.down("sm")]: {
              "& > div": {
                display: "flex",
                flexDirection: "column",
              },
            },
          })}
        >
          <div>
            <Typography variant="subtitle1" color="text.secondary">
              Theme
            </Typography>
            <ButtonGroup size="small" fullWidth>
              <Button
                color={mode === "light" ? "secondary" : "primary"}
                variant="contained"
                onClick={() => setMode("light")}
              >
                Light
              </Button>
              <Button
                color={mode === "system" ? "secondary" : "primary"}
                variant="contained"
                onClick={() => setMode("system")}
              >
                System
              </Button>
              <Button
                color={mode === "dark" ? "secondary" : "primary"}
                variant="contained"
                onClick={() => setMode("dark")}
              >
                Dark
              </Button>
            </ButtonGroup>
          </div>
          <Divider />
          <div>
            <Typography variant="subtitle1" color="text.secondary">
              Messenger Unit
            </Typography>
            <TextField
              size="small"
              variant="filled"
              fullWidth
              color="accent"
              placeholder={defaultConfig.MU_URL}
              value={tempConfig.MU_URL}
              onChange={(e) => setTempConfig({ ...tempConfig, MU_URL: e.target.value })}
            />
          </div>
          <div>
            <Typography variant="subtitle1" color="text.secondary">
              Compute Unit
            </Typography>
            <TextField
              size="small"
              variant="filled"
              fullWidth
              color="accent"
              placeholder={defaultConfig.CU_URL}
              value={tempConfig.CU_URL}
              onChange={(e) => setTempConfig({ ...tempConfig, CU_URL: e.target.value })}
            />
          </div>
          <div>
            <Typography variant="subtitle1" color="text.secondary">
              Gateway
            </Typography>
            <TextField
              size="small"
              variant="filled"
              fullWidth
              color="accent"
              placeholder={defaultConfig.GATEWAY_URL}
              value={tempConfig.GATEWAY_URL}
              onChange={(e) => setTempConfig({ ...tempConfig, GATEWAY_URL: e.target.value })}
            />
          </div>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={save}
            endIcon={saved ? <Check /> : <Save01 />}
          >
            Save
          </Button>
        </Stack>
      </Paper>
    </PageWrapper>
  )
}
